var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"key-value-unit-blood-oxygen-report"},[_c('key-value-unit',{attrs:{"title":_vm.title,"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }